// extracted by mini-css-extract-plugin
export var table = "_tj-0";